import { EstimateType } from 'types/store';

export const baseSpacingPixelValue = 4;
export const spacing = (multiplier: number) => `${multiplier * baseSpacingPixelValue}px`;

export const getAverageEstimate = (estimate: EstimateType) => (estimate[0] + estimate[1]) / 2;
